<ng-container *ngIf="!newTableStyle else newStyle">
  <app-data-list *ngIf="!basicStyle else basic"
                 [displayLimit]="10"
                 [toggleTitle]="'More Details'"
                 [title]="title"
                 [loading]="loadingBorrowerValues$ | async"
                 [dataList]="dataList$ | async"
                 (editClicked)="handleEdit()"
  >
  </app-data-list>
  <ng-template #basic>
    <app-data-list-simple
      [title]="title"
      [dataList]="dataList$ | async"
      [loading]="loadingBorrowerValues$ | async">
    </app-data-list-simple>
  </ng-template>
</ng-container>

<ng-template #newStyle>
  <app-borrower-data-table *ngIf="tab !== 'erc'"
    [title]="title"
    [loading]="loadingBorrowerValues$ | async"
    [dataList]="dataList$ | async"
    (editClicked)="handleEdit()"
  >
  </app-borrower-data-table>
  <app-erc-data-table *ngIf="tab === 'erc'"
    [title]="title"
    [loading]="loadingBorrowerValues$ | async"
    [businessStartDate]="businessStartDate"
    [borrowerValues]="borrowerValues$ | async"
    (editClicked)="handleEdit()"
  >
  </app-erc-data-table>
</ng-template>
